<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="A" itemcode="A-QBLY"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="heightVh95 whitebox container-flex-center">
					<freeUserTips :type="4" :bgtype="0" isShowPageTitle="全部企业"></freeUserTips>
				</div> 
			</div>
		</div>
		 
		 
	</div> 
</template>

<script> 
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'allBuildings',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				title: "全部楼宇",
				searchPlaceholder:'全部楼宇库', industrytype:1,
				areaData:[],
				countyData:[{county:0,countyName:"全深圳"}],
				areaId:0,
				streetData:[],
				streetId:0,
				countyid:0,
				dimesmlist:[{
					name: '在营企业数',
					type: 0
				}, {
					name: '独角兽',
					type: 6
				}, {
					name: '上市公司',
					type: 7
				}, {
					name: '国有企业',
					type: 8
				}, {
					name: '专精特新',
					type: 9
				}, {
					name: '专精特新小巨人',
					type: 10
				}, {
					name: '创新型中小型企业',
					type: 11
				}, {
					name: '今年迁入',
					type: 4
				}, {
					name: '今年迁出',
					type: 5
				},], 
				hotindustry:[],hotindustrychild:[], industrycode1:"",industrycode2:'',industryid:0, 
				userdata: {}, 
				enterpristlist: [],  
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "", 
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数    
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序    
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '', 
				
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				//外资企业筛选列表：0=注册资本,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
			 
			  
			}
		},
		beforeCreate() {
			this.bus.$emit('loading', true);
		},  
		created() { 
		},
		mounted() {
		},
		methods: {  
			//位置区域选择选择
			areaChoosed(item) {
				this.countyid=item.county;
				this.streetData=this.areaData.filter(list=>{
					return list.county==item.county;
				});
				this.streetChoosed({id:0});
			},
			streetChoosed(list){
				this.streetId=list.id; 
				this.getCompanyList();
			},
			//获取区域街道信息
			getStreetData(){
				var ajaxurl = this.$api.park.building.areaList();
				var _this = this;
				console.log(ajaxurl,this.userdata.token)
				// console.log(ajaxurl)
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
				 console.log(res.data.list) 
					_this.areaData=res.data.list;
					let str="",data=res.data.list;
					for(var i=0;i<data.length;i++){
						if(str.indexOf(data[i].countyName)<0){
							str+=data[i].countyName;
							_this.countyData.push({countyName:data[i].countyName,county:data[i].county})
						}  
					}
					_this.streetData=[];  
					_this.getCompanyList();
				}).catch(function(error) {});
			
			},  
 
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getCompanyList();
			},
			//搜索关键词
			searchkwfun() {
				this.searchtext = $.trim(this.searchtext);
				// if(this.searchtext!="" || ){
				this.getCompanyList();
				// } 
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
			// pageHandler: function(page) { 
			// 	console.log('pageHandler',this.userdata.groupType==0,page > 2)
			// 	this.getCompanyList(page);
			// }, 
			getCompanyList(pages) {   
				this.bus.$emit('loading', true); 
				this.page=pages?pages:1; 
				var _this = this;  
				var ajaxurl = this.$api.park.building.list()+'?county='+this.countyid+'&area='+this.streetId+'&kw='+this.searchtext+'&page='+this.page+'&orderField='+this.orderField+'&orderType='+this.orderType;
	 
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('楼宇列表', res.data.list); 
						var dataenterlist= res.data.list; 
						//页数和导出
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.haspage = res.data.list.length == res.data.pageSize; 
						_this.kwtextsearch = _this.searchtext != "";
						_this.kwtextsearchtext = _this.searchtext; 
						_this.enterpristlist=dataenterlist; 
						_this.bus.$emit('loading', false);
				 
				}).catch(function(error) {});
				// console.log(datas);  
			},
 
			//  
		}
	}
</script>

<style scoped>
	/* .td_sortname{
		width: 96px;padding-left: 2px;padding-right: 25px;
	} */
</style>
